<template>
    <div>
        <component-wrapper :config="component" @click.native="openBookingDialog" />

        <v-dialog v-model="showBookingDialog" max-width="850px" persistent>
            <v-card class="zoezi-bottom-sheet">
                <course-booking :course-id="courseId" :showSpaceLeft="showSpaceLeft" dialog @close="closeBookingDialog" />
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import components from '../component.js';
import CourseBooking from "./CourseBooking.vue";

export default {
    name: "zoezi-course-booking-button",
    zoezi: {
        title: 'Course booking button',
        icon: 'mdi-book',
        addon: 'Courses'
    },
    components: {
        CourseBooking,
    },
    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({ component: 'zoezi-button', props: { text: 'Book' } })
        },
        courseId: {
            title: 'Course',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$zoeziapi.get('/api/course/get', { compact: true, bookable: true, fields: 'product.name,id' }).then(courses => courses.map(course => ({ id: course.id, name: course.product.name }))),
                selectFirst: true
            }
        },
        showSpaceLeft: {
            title: 'Show number of places left',
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showBookingDialog: false,
        };
    },
    methods: {
        openBookingDialog() {
            this.showBookingDialog = true;
        },
        closeBookingDialog() {
            this.showBookingDialog = false;
        },
    },
}
</script>
